import { push } from "connected-react-router";

import { getTemplatesList } from '../../request';
import { checkAndRenewTokens, checkTokenError } from "./auth";
import { clearTemplateForm } from "./editTemplate";
import { showErrorMessage, hideErrorMessage } from "./ui";

//Загрузка списка шаблонов
export const TEMPLATES_LOADING_START = "Templates loading start";
export const TEMPLATES_LOADING_SUCCESS = "Templates list loading success";
export const TEMPLATES_LOADING_FAILED = "Failure during templates list load";

//Пагинация
export const CHANGE_TEMPLATES_PAGE = "Change templates page";
export const CHANGE_TEMPLATES_LIMIT = "Change templates limit";

export const GO_TO_TEMPLATE_CREATION = "Go to template creation";

const startLoading = () => ({
  type: TEMPLATES_LOADING_START
});

const loadSuccess = templates => ({
  type: TEMPLATES_LOADING_SUCCESS,
  payload: {
    templates: templates || []
  }
});

const loadFailure = () => ({
  type: TEMPLATES_LOADING_FAILED,
});


//Загрузка списка шаблонов
export const getTemplatesListAsync = payload => {
  return async (dispatch) => {
    dispatch(startLoading());
    dispatch(hideErrorMessage());
    await dispatch(checkAndRenewTokens());
    let templates;
    try {
      const accessToken = localStorage.getItem("accessToken");
      templates = await getTemplatesList(accessToken, payload);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке списка шаблонов!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(templates));
  };
};

export const goToTemplateCreation = () => {
  return async (dispatch) => {
    dispatch(clearTemplateForm());
    dispatch(push('/create-template'));
  };
};

//Пагинация на странице списка шаблонов
export const changeTemplatesPage = activePage => ({
  type: CHANGE_TEMPLATES_PAGE,
  payload: { activePage }
});

//Отображение элементов на странице списка шаблонов
export const changeTemplatesLimit = activeLimit => ({
  type: CHANGE_TEMPLATES_LIMIT,
  payload: { activeLimit }
});